import { render, staticRenderFns } from "./CardRenderTileComponent.vue?vue&type=template&id=10cb5836&"
import script from "./CardRenderTileComponent.vue?vue&type=script&lang=ts&"
export * from "./CardRenderTileComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports